import { IonSpinner } from "@ionic/react";
import camelize from "../../../../../global/utils/camelize";
import { funAcortarText } from "../../../../../global/utils/text";
import UserIcon from "../../../../assets/images/UserIcon";
import { BodyCardSelect, ContainerCardSelect, TopCardSelect } from "./localStyle"

const CardSelect = ({nombreDoc, matNac, matProv, onclick, loading}) => {
    return (
        <ContainerCardSelect>
            <TopCardSelect>
                <UserIcon color={"white"}/> <span>Dr. {funAcortarText(20,camelize(nombreDoc)) }</span>
            </TopCardSelect>
            <BodyCardSelect>
                <div>
                    <span className="text">M. Nacional: <span className="bold">{matNac}</span></span>
                    <span className="text">M. Provincial: <span className="bold">{matProv}</span></span>
                </div>
                <button onClick={onclick}>
                    {loading ? 
                    <span>
                        <IonSpinner name="lines"/>
                    </span>
                    : "Seleccionar"}
                </button>
            </BodyCardSelect>
        </ContainerCardSelect>
    )
}

export default CardSelect; 